import { FormattedMessageDiv, FormattedNumberDiv, Card, Tooltip } from "@odmonorepo/core-components"
import {  Stack } from "react-bootstrap"
import { FormattedMessage, useIntl } from "react-intl"
import { codToCents } from "../OfferReview/codToCents"
import { LOCCostsAndFees } from "./LOCCostsAndFees"

export const LOCDetails = ({ offer}) => {
    const intl = useIntl();
    return (
        <Card className="bg-light-gray shadow-none" 
          bodyClassName="p-md-5 px-md-6 p-4">
          <Stack gap={3}>
            <FormattedMessageDiv
              className="fw-bold fs-5 text-start"
              id="offerPreview.lineOfCreditDetails"
            />
            <Stack direction="horizontal" className="align-items-end">
              <FormattedMessageDiv id="offerReview.locApprovedCreditLimit" />
              <FormattedNumberDiv
                value={offer.pricedDetails.lineAmount}
                style="currency"
                currency="USD"
                className="ms-auto"
              />
            </Stack>
            <Stack direction="horizontal" className="align-items-end">
              <div>
                <FormattedMessage id="offerPreview.term" />
                <Tooltip
                  color="blue"
                  title={intl.formatMessage(
                    { id: 'offerPreview.termTooltipText' },
                    { term: offer.pricedDetails.term },
                  )}
                />
              </div>
              <FormattedNumberDiv
                value={offer.pricedDetails.term}
                suffix=" Months"
                className="ms-auto"
              />
            </Stack>
            <Stack direction="horizontal" className="align-items-end">
              <div>
                <FormattedMessage id="offerPreview.cod" />
                <Tooltip
                  color="blue"
                  title={intl.formatMessage({
                    id: 'offerPreview.codTooltipText',
                  })}
                />
              </div>
              <FormattedNumberDiv
                value={codToCents(offer.pricedDetails.trueCentsOnDollar)}
                suffix="&cent;"
                className="ms-auto"
                roundingMode="ceil"
                minimumFractionDigits={1}
                maximumFractionDigits={4}
              />
            </Stack>
            <Stack direction="horizontal" className="align-items-end">
              <div>
                <FormattedMessage id={`offerPreview.apr`} />
                <Tooltip
                  title={intl.formatMessage({
                    id: `offerPreview.apr.tooltip`,
                  })}
                />
              </div>
              <FormattedNumberDiv
                value={offer.pricedDetails.trueAPR}
                suffix="%"
                maximumFractionDigits={4}
                className="ms-auto"
              />
            </Stack>
            <Stack direction="horizontal" className="align-items-end">
              <div>
                <FormattedMessage id="offerReview.rid" />
              </div>
              <FormattedNumberDiv
                value={offer.requiredInitialDraw}
                style="currency"
                currency="USD"
                className="ms-auto"
              />
            </Stack>
          </Stack>
        </Card>
    )
}